import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=1d784488&scoped=true"
import script from "./Menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./Menu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Menu.vue?vue&type=style&index=0&id=1d784488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d784488",
  null
  
)

export default component.exports